import { Box } from '@mui/material'
import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import { AppDispatch } from '../../store'
import { CompanyPreferencesActions } from '../../store/companyPreferences'
import { AllProjects, Project } from './subComponents'
import { AgenciesActions } from '../../store/agencies'

export const Projects: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(AgenciesActions.fetchAgenciesAsync())
    dispatch(CompanyPreferencesActions.fetchCompanyPreferencesAsync())
  }, [dispatch])

  return (
    <Box width="100%">
      <Routes>
        <Route index path="/" element={<AllProjects />} />
        <Route path="/:projectId" element={<Project />} />
      </Routes>
    </Box>
  )
}
